import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AlertService } from 'src/app/Service/Alert/Alert.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Alert_Interface, Empty_Alert_Interface } from 'src/app/Interface/Alert_Interface';
import { Chart_Interface } from 'src/app/Interface/Chart_Interface';
import { ChartService } from 'src/app/Service/Chart/Chart.service';

@Component({
  selector: 'app-AlertForm',
  templateUrl: './AlertForm.component.html',
  styleUrls: ['./AlertForm.component.css']
})
export class AlertFormComponent implements OnInit {

  @Input() inner_Alert: Alert_Interface = Empty_Alert_Interface()

  Title: String = ""
  Customer: String = "0"
  ExpirationDate: String = ""

  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>متن خود را اینجا تایپ کنید ...</p>'
  };
  public config = {
    language: 'fa'
  };

  constructor(
    private Alertify_Service: AlertifyService,
    private Alert_Service: AlertService,
    private Chart_Service: ChartService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
  ) { }

  ngOnInit() {

    this.Title = this.inner_Alert.title
    if (this.inner_Alert.customer == true && this.inner_Alert.id > 0) {
      this.Customer = "2"
    }
    else if (this.inner_Alert.customer == false && this.inner_Alert.id > 0) {
      this.Customer = "1"
    }
    this.UploadImageSrc_List = this.inner_Alert.files
    this.ExpirationDate = this.inner_Alert.expirationData
    this.model.editorData = this.inner_Alert.message


    this.Nav_Service.CheckValidPage(1144).subscribe(
      data => {
        this.GetRecord_Chart()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  //#region Image
  BaseUrl = environment.BaseUrl
  UploadImageSrc_List: Array<string> = []
  UploadImageSrc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.Alert_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  Add_uploadImage1() {
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc = ''
    this.Alertify_Service.SuccessMessage("به جدول اضافه شد")
  }

  UploadImageSrc_List_Delete(id: number) {
    this.UploadImageSrc_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  modalRef_Image: any;
  ModalimageUrl: string = ''
  openModal(template: TemplateRef<any>, imageUrl: string) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion

  //#region Form

  InProccessingAdd: boolean = false
  Selected_Tag: Array<Chart_Interface> = []
  DataList_Chart: Array<Chart_Interface> = []


  OnGet_Selected_Tag(item: Array<Chart_Interface>) {
    this.Selected_Tag = item
  }

  GetRecord_Chart() {
    this.Chart_Service.GetAlert(this.inner_Alert.id).subscribe(
      data => {
        this.DataList_Chart = data['result']
        this.Selected_Tag = data['alert']
      },
      error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#endregion

  InProccessing: boolean = false
  onSubmitForm() {

    if (!this.Title) {
      this.Alertify_Service.ErrorMessage("عنوان اطلاعیه را وارد نمائید")
    }
    else if (this.Customer == "0") {
      this.Alertify_Service.ErrorMessage("کاربران را انتخاب نمائید")
    }
    else {

      var chart_id:Array<number>=[]
      for(let item of this.Selected_Tag)
      {
        chart_id.push(item.id)
      }

      this.InProccessing = true
      this.Alert_Service.SubmitAlert(
        this.inner_Alert.id,
        this.model.editorData,
        this.Customer == "2",
        this.Title.trim(),
        this.ExpirationDate,
        chart_id,
        this.UploadImageSrc_List
      ).subscribe(
        data => {
          this.inner_Alert.id = data.id
          this.Alertify_Service.SuccessMessage("اطلاعیه در سامانه ثبت شد")
          this.InProccessing = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )

    }

  }

}
